export const priceBystaffGroups = [
  { group: '1 – 30', price: 70 },
  { group: '31– 50', price: 130 },
  { group: '51– 100', price: 200 },
  { group: '101 – 150', price: 270 },
  { group: '150 – 200', price: 300 },
  { group: '201 – 250', price: 375 },
  { group: '251 – 300', price: 450 },
  { group: '> 300', price: 0 }, // 0 means individual price
];

export const staffGroups = priceBystaffGroups.map(el => el.group);

export const currencies = {
  eur: { symbol: '€', code: 'EUR', price: null },
  usd: { symbol: '$', code: 'USD', price: null },
  uah: { symbol: '₴', code: 'UAH', price: 1 },
};

export const discountByMonth = {
  1: 0,
  3: 10,
  6: 15,
  12: 20,
};